module.exports = __webpack_public_path__ + "static/media/dgData.b6c91fdf.svg";